'use client';

import Script from 'next/script';
import { adEventName } from '@/app/lib/ad-events';
import { useCookieConsent } from '@/app/stores/cookie-consent-store';

const FACEBOOK_PIXEL_ID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID;

const FacebookPixel = () => {
  const { isAccepted } = useCookieConsent();

  if (!FACEBOOK_PIXEL_ID || !isAccepted) return null;

  return (
    <>
      <Script id="facebook-pixel" strategy="afterInteractive">
        {`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${FACEBOOK_PIXEL_ID}');
          fbq('track', 'PageView');
        `}
      </Script>
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          src={`https://www.facebook.com/tr?id=${FACEBOOK_PIXEL_ID}&ev=PageView&noscript=1`}
          alt=""
        />
      </noscript>
    </>
  );
};

export default FacebookPixel;

// `fbq('track')` takes only Facebook's own standard events; anything else has to go through
// `trackCustom`. These are the standard names we send.
const FACEBOOK_STANDARD_EVENTS = new Set(['Purchase', 'CompleteRegistration']);

/** Sends one event to the Facebook pixel, under the name the ad platforms know it by. */
export const trackFacebookEvent = (event: string, params?: Record<string, any>) => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    const name = adEventName(event);
    (window as any).fbq(FACEBOOK_STANDARD_EVENTS.has(name) ? 'track' : 'trackCustom', name, params);
  }
};
